
import { useState, FormEvent } from 'react';

export default function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setMessage('Please enter a valid email address');
      setTimeout(() => setMessage(''), 3000);
      return;
    }

    setIsSubmitting(true);
    
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d5infn3gekujqjrtt2sg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString()
      });

      if (response.ok) {
        setMessage('🎉 Successfully subscribed! Check your inbox.');
        setEmail('');
      } else {
        setMessage('Something went wrong. Please try again.');
      }
    } catch (error) {
      setMessage('Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setMessage(''), 5000);
    }
  };

  return (
    <div className="bg-gradient-to-r from-teal-500 to-emerald-500 py-16">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
          <i className="ri-mail-send-line text-5xl text-white"></i>
        </div>
        <h2 className="text-3xl font-bold text-white mb-3">
          Stay Updated with Exclusive Offers
        </h2>
        <p className="text-white/90 text-lg mb-8">
          Subscribe to our newsletter and get 15% off your first purchase!
        </p>
        
        <form 
          id="newsletter-form"
          data-readdy-form
          onSubmit={handleSubmit} 
          className="max-w-md mx-auto"
        >
          <div className="flex gap-3">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className="flex-1 px-5 py-3 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-white/50"
              required
              disabled={isSubmitting}
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-8 py-3 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
            >
              {isSubmitting ? 'Subscribing...' : 'Subscribe'}
            </button>
          </div>
          {message && (
            <p className={`mt-4 text-sm font-medium ${message.includes('Successfully') ? 'text-white' : 'text-yellow-200'}`}>
              {message}
            </p>
          )}
        </form>
        
        <p className="text-white/70 text-sm mt-4">
          We respect your privacy. Unsubscribe anytime.
        </p>
      </div>
    </div>
  );
}
